<ng-container *transloco="let t">
  <mat-toolbar color="primary" class="flex space-between" [class.header-toolbar--mobile-actions]="isMobile">
    <div class="flex align-center">
      @if (isLoggedIn && ![5, 9, 13].includes(roleId)) {
        <button mat-icon-button (click)="navbarToggled.emit(!navbarOpen)">
          <mat-icon>{{ navbarOpen ? 'menu_open' : 'menu' }}</mat-icon>
        </button>
      }
      <a mat-button routerLink="/" class="hidden-xs" style="position: relative;">
        <span class="header-logo flex align-center"><img src="/assets/logo/company_logo.png" alt="Company logo" /></span>
        @if (appMode !== 'production') {
          <div [class]="`header-overlay ${appMode}`">{{ appMode }}</div>
        }
      </a>
      <a mat-button routerLink="/" class="visible-xs">
        <span class="header-logo flex align-center">
          <img class="radius-4px" src="/assets/icons/icon-192x192.png" alt="Application icon" />
        </span>
      </a>
    </div>
    @if (isPersonnelRoute) {
      <span class="header-logo flex align-center caresonal-header">
        <img class="radius-4px" src="/assets/caresonal/Caresonal-logo-tansparent-hor.png" alt="Caresonal logo" />
        @if (hrJwtRemainingText) {
          <span
            class="hr-jwt-remaining"
            [class.hr-jwt-remaining--low]="hrJwtRemainingLow"
            [matTooltip]="t('personnel.session.remaining_tooltip', { time: hrJwtRemainingText })"
          >
            <mat-icon class="material-symbols-outlined">schedule</mat-icon>
            {{ hrJwtRemainingText }}
          </span>
        }
      </span>
    }
    <div class="flex align-center header-toolbar-actions">
      @if (jwtService.isMimic) {
        <button mat-icon-button (click)="mimicReset()" matTooltip="Nutzerlogin beenden">
          <mat-icon>lock_reset</mat-icon>
        </button>
      }

      @if (isMobile) {
        <button
          mat-icon-button
          type="button"
          [matMenuTriggerFor]="languagesSelector"
          [attr.aria-label]="t('menu.top.language')"
        >
          <mat-icon>translate</mat-icon>
        </button>
      } @else {
        <button mat-button type="button" [matMenuTriggerFor]="languagesSelector">
          <mat-icon>translate</mat-icon>
          {{ t('menu.top.language') }}
        </button>
      }
      <mat-menu #languagesSelector>
        @for (lang of languages; track lang) {
          <button mat-menu-item [class.active]="memoryService.language === lang.value" (click)="memoryService.changeLanguage(lang.value)">{{ lang.label }}</button>
        }
      </mat-menu>

      <mat-menu #supportMenu="matMenu" xPosition="before">
        <a mat-menu-item [routerLink]="helpLink">
          <mat-icon class="material-symbols-outlined">help</mat-icon> {{ t('support.help.menu') }}
        </a>
        @if (isLoggedIn) {
          <button mat-menu-item type="button" (click)="openChangelogDialog()">
            <mat-icon class="material-symbols-outlined">newspaper</mat-icon> {{ t('support.changelog_title') }}
          </button>
        }
        <button mat-menu-item (click)="onSupportClicked()"><mat-icon>edit</mat-icon> {{ t('support.write') }}</button>
        @if ('view.support.tickets' | capabilityCheck: false : jwtService.userData) {
          <a mat-menu-item routerLink="/support/tickets">
            <mat-icon>receipt_long</mat-icon> {{ t('support.overview') }}
          </a>
        }
        @if ('support.translate.status' | capabilityCheck: false : jwtService.userData) {
          <a mat-menu-item routerLink="/support/translation-status">
            <mat-icon>translate</mat-icon> {{ t('translation_status.title') }}
          </a>
        }
        @if ('support.onboarding-guide.edit' | capabilityCheck: false : jwtService.userData) {
          <a mat-menu-item routerLink="/support/guides">
            <mat-icon class="material-symbols-outlined">library_books</mat-icon> {{ t('support.guide_management.menu') }}
          </a>
          <a mat-menu-item routerLink="/support/onboarding-guide">
            <mat-icon class="material-symbols-outlined">menu_book</mat-icon> {{ t('support.onboarding_guide.menu') }}
          </a>
        }
        <!-- Meilensteine: siehe support-views.module.ts (milestones-Route) -->
        <!-- @if ('support.epic.view' | capabilityCheck: false : jwtService.userData) {
          <a mat-menu-item routerLink="/support/milestones">
            <mat-icon>task</mat-icon> {{ t('support.milestones') }}
          </a>
        } -->
        @if ('all' | capabilityCheck: false : jwtService.userData) {
          <a mat-menu-item routerLink="/process-history">
            <mat-icon class="material-symbols-outlined">account_tree</mat-icon> {{ t('support.process_history') }}
          </a>
        }
        @if ('history.view' | capabilityCheck: false : jwtService.userData) {
          <a mat-menu-item routerLink="/history">
            <mat-icon class="material-symbols-outlined">history</mat-icon> History
          </a>
        }
        <button mat-menu-item (click)="reload()"><mat-icon>refresh</mat-icon> Refresh</button>
      </mat-menu>
      @if (isMobile) {
        <button
          mat-icon-button
          type="button"
          [matMenuTriggerFor]="supportMenu"
          [attr.aria-label]="t('menu.top.help')"
        >
          <mat-icon class="material-symbols-outlined">contact_support</mat-icon>
        </button>
      } @else {
        <button mat-button type="button" [matMenuTriggerFor]="supportMenu">
          <mat-icon class="material-symbols-outlined">contact_support</mat-icon>
          Support
        </button>
      }

      @if (isLoggedIn) {
        @if ('user.notification.view' | capabilityCheck: false : jwtService.userData) {
          <app-notification-dropdown/>
        }
        <app-user-avatar/>
      }
    </div>
  </mat-toolbar>
</ng-container>
